module.exports = __webpack_public_path__ + "static/media/Avatar_Member_Default.6327305b.png";